import type { FolderForDialog } from "@types"

/**
 * Valide qu'un nœud a la shape attendue (premier niveau uniquement).
 */
function isFolderForDialogNode(node: unknown): node is FolderForDialog {
    if (!node || typeof node !== "object") return false
    const n = node as Record<string, unknown>
    if (typeof n._id !== "string" || typeof n.name !== "string") return false
    if (n.buildings !== undefined && !Array.isArray(n.buildings)) return false
    if (n.children !== undefined && !Array.isArray(n.children)) return false
    return true
}

/**
 * Valide la prop folders : tableau d'objets avec _id, name, optionnellement buildings (array) et children (array).
 */
export function validateFolders(value: unknown): value is FolderForDialog[] {
    if (!Array.isArray(value)) return false
    return value.every(isFolderForDialogNode)
}
